import { App } from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { installErrorTracking } from "@/lib/error-tracking";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";

// Instala a captura de erros não tratados antes de montar a aplicação — assim
// falhas no próprio bootstrap também são reportadas.
installErrorTracking();

const container = document.getElementById("root");

if (!container) {
  throw new Error('Elemento raiz "#root" não encontrado no documento.');
}

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
